export default "__VITE_ASSET__BYCLAAPg__"